import { ContentStatus, useContentEntry } from '@soluto-home-web/platform-core';
import { useAdobeAnalytics, useUser } from 'packages/smart-home-support/hooks';
import React from 'react';
import { useTweekValue } from 'react-tweek';
import { LoadingOverlay } from '../../components';
import { DevicesPageContent } from '../fees-and-deductibles/models';
import { Container } from '../signup/components/Common';
import WhatsCoveredPageContent from './WhatsCoveredPageContent';
import WhatsCoveredOriginal from './WhatsCoveredOriginal';
import { isInTestGroup } from 'packages/smart-home-support/utils';
import { TestGroup } from 'packages/smart-home-support/models';

const WhatsCoveredContentfulRenderer: React.FC = () => {
  useAdobeAnalytics();

  const contentId = useTweekValue('soluto_home_web/smart_home_support/pages/whats_covered/content_id', '');
  const content = useContentEntry<DevicesPageContent>(contentId);

  return (
    <Container>
      <LoadingOverlay in={content.status === ContentStatus.loading} isFullPage />
      {content.status === ContentStatus.loaded && <WhatsCoveredPageContent {...content.data.fields} />}
    </Container>
  );
};

const WhatsCoveredPage: React.FC = () => {
  const user = useUser();
  const showContentfulVersion = isInTestGroup(user, TestGroup.WhatsCovered_Redesign);

  return showContentfulVersion
    ? (<WhatsCoveredContentfulRenderer />)
    : (<WhatsCoveredOriginal />);
};

export default WhatsCoveredPage;


// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/whats-covered/index.tsx